import { render } from "./Eyes.vue?vue&type=template&id=c83b49ac"
import script from "./Eyes.vue?vue&type=script&lang=js"
export * from "./Eyes.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/projects/projects/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__